module.exports = __webpack_public_path__ + "static/media/footui_1.bf9cc775.png";